import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { TEnterprise } from '../../utils/types';

const initialState: TEnterprise[] | [] = [];

export const companySlice = createSlice({
  name: 'companySlice',
  initialState,
  reducers: {
    updateCompany: (
      _state,
      action: PayloadAction<TEnterprise[]>
    ) => ({ ...action.payload }),
  },
});

export const { updateCompany } = companySlice.actions;

export default companySlice.reducer;
